const delay = (n) => {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
};

const GravityFormsFix = (n) => {
  const requiredSpans = document.querySelectorAll(".gfield_required_text");
  if (requiredSpans) {
    requiredSpans.forEach((span) => (span.textContent = "*"));
  }
};

export { delay, GravityFormsFix };
